import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  Icon,
  SimpleGrid,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { HeaderCard } from "../../../components/headerCard";
import { RiCloseFill, RiEqualLine } from "react-icons/ri";
import React, { useEffect, useState } from "react";
import { api } from "../../../service/api";
import { ProductUpdateDTO } from "../../../dtos/ProductUpdateDTO";
import {
  formatCurrency,
  formatedMonthDay,
  statusUpdatePrice,
  typeUpdatePrice,
} from "../../../utils/utils";
import { ModalProductUpdate } from "../modal/modal-product-update";

export function UpdatePriceList() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const [productInfo, setProductInfo] = useState<ProductUpdateDTO>(
    {} as ProductUpdateDTO
  );

  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [isModalTable, setIsModalTable] = useState(false);

  const [productData, setProductData] = useState<ProductUpdateDTO[]>([]);

  const cancelRef = React.useRef<any>(null);

  async function deleteProdcut(productId: string) {
    try {
      setLoadingDelete(true);
      await api.delete(`product/update/price/delete/${productId}`);
      toast({
        position: "top-right",
        title: "Produto",
        description: "Atualização removida com sucesso.",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        position: "top-right",
        title: "Produto",
        description: "Não foi remover atualização.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } finally {
      setLoadingDelete(false);
      onClose();
      setProductInfo({} as ProductUpdateDTO);
      getProducts();
    }
  }

  async function getProducts() {
    try {
      setLoading(true);
      const response = await api.get("product/update/list");
      setProductData(response.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <Box>
      <HeaderCard
        title="LISTA DE  ATUALIZAÇÃO DE PREÇOS"
        titleButton="Nova atualizaçāo"
        link="/atualizar-precos/novo"
      />

      <ModalProductUpdate
        is_open={isModalTable}
        onClose={() => {
          setIsModalTable(false);
        }}
        update_product_id={productInfo.id}
      />

      {loading && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={500}
        >
          <Spinner
            color="green.600"
            emptyColor="white"
            thickness="4px"
            size="xl"
            h={100}
            w={100}
          />
        </Box>
      )}

      <SimpleGrid
        flex="1"
        gap="4"
        minChildWidth="320px"
        alignItems="flex-start"
        px={1}
        py={1}
      >
        {productData.length > 0 && !loading && (
          <Box p="4" borderRadius={8} height={500}>
            <TableContainer>
              <Table variant="striped" colorScheme="gray" size="sm">
                <Thead>
                  <Tr bg="green.600" height="10">
                    <Th color="white" textAlign="center">
                      STATUS
                    </Th>
                    <Th color="white" textAlign="center">
                      DATA
                    </Th>
                    <Th color="white" textAlign="center">
                      TIPO DE ATUALIZAÇÃO
                    </Th>
                    <Th color="white" textAlign="center">
                      MOTIVO
                    </Th>
                    <Th color="white" textAlign="center">
                      INDICE
                    </Th>
                    <Th color="white" textAlign="center">
                      OBSERVAÇÕES
                    </Th>
                    <Th color="white" textAlign="center">
                      AÇÕES
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {productData.map((item, index) => (
                    <Tr key={index}>
                      <Td textAlign="center">
                        {statusUpdatePrice(item.status)}
                      </Td>
                      <Td textAlign="center">
                        {formatedMonthDay(item.data_update)}
                      </Td>
                      <Td textAlign="center">
                        {typeUpdatePrice(item.type_update)}
                      </Td>
                      <Td textAlign="center">{item.motive}</Td>
                      <Td textAlign="center">
                        {formatCurrency(item.indication)}%
                      </Td>
                      <Td>{item.observation}</Td>
                      <Td textAlign="center" width="10">
                        <Button
                          size="sm"
                          fontSize="sm"
                          onClick={() => {
                            console.log("Aqui");
                            setProductInfo(item);
                            setIsModalTable(true);
                          }}
                        >
                          <Icon fontSize="16px" as={RiEqualLine} />
                        </Button>
                        <Button
                          size="sm"
                          ml={1}
                          fontSize="sm"
                          onClick={() => {
                            setProductInfo(item);
                            onOpen();
                          }}
                        >
                          <Icon fontSize="16px" as={RiCloseFill} />
                        </Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </SimpleGrid>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
        motionPreset="slideInBottom"
        closeOnEsc={false}
        closeOnOverlayClick={false}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Remover produto/serviço
            </AlertDialogHeader>

            <AlertDialogBody>
              {!loadingDelete && (
                <Text>
                  Deseja remover o atualização de:{" "}
                  <strong>
                    {formatCurrency(productInfo.indication ?? 0)}%
                  </strong>
                </Text>
              )}

              {loadingDelete && (
                <Flex width="100%" alignItems="center" justifyContent="center">
                  <Spinner
                    color="green.600"
                    emptyColor="white"
                    thickness="4px"
                    size="xl"
                    h={50}
                    w={50}
                  />
                </Flex>
              )}
            </AlertDialogBody>

            <AlertDialogFooter>
              {!loadingDelete && (
                <>
                  <Button
                    colorScheme="red"
                    onClick={() => {
                      deleteProdcut(productInfo?.id);
                    }}
                  >
                    Sim
                  </Button>
                  <Button ml={3} onClick={onClose}>
                    Nāo
                  </Button>
                </>
              )}
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
}
